import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import HeroSection from './components/HeroSection';
import FounderSection from './components/FounderSection';
import ValuesSection from './components/ValuesSection';
import TeamSection from './components/TeamSection';
import CultureSection from './components/CultureSection';
import RecognitionSection from './components/RecognitionSection';
import CTASection from '../homepage/components/CTASection';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'About Us - Devontis Technologies | Our Story & Team';
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
          <Breadcrumbs />
        </div> */}
        
        <HeroSection />
        <FounderSection />
        <ValuesSection />
        {/* <TeamSection /> */}
        <CultureSection />
        {/* <RecognitionSection /> */}
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default About;